import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import { USER_LISTS } from "src/constants/permissions";
import { ActionButton, InputSelector } from "../../components/style";
import { AUDIENCE_ACTIONS_LIST } from "../../constants";
import { TextLabel } from "src/components";
import { EmailCampaignsContext } from "../../EmailCampaignsContext";
import { USER_GROUP } from "src/constants/perks";

export default function TableAudienceActions(props) {
    const { selectedAction, audience, onChangeAction } = props;
    const { user } = useContext(EmailCampaignsContext);
    const history = useHistory();

    const userHasMyUserListsPermission = user.permissions.includes(USER_LISTS);
    const goToMyUserLists = () => {
        if (!userHasMyUserListsPermission) {
            return;
        }
        history.push({
            pathname: "/employList",
            search: `?isClient=${audience.name === USER_GROUP.CLIENTS}`,
        });

    };

    return (
        <>
            {audience.name === "clients" || audience.name === "employees" ?
                <ActionButton
                    width="160px"
                    backgroundColor={userHasMyUserListsPermission ? "#000000" : "#C0C0C0"}
                    border={userHasMyUserListsPermission ? "1px solid black" : "none"}
                    height="32px"
                    onClick={goToMyUserLists}
                >
                    <TextLabel size="12px" color="#FFFFFF">
                        Manage via My User Lists
                    </TextLabel>
                </ActionButton> :
                <InputSelector
                    value={selectedAction[audience.uuid] ? selectedAction[audience.uuid] : "selectAction"}
                    onChange={(e) =>
                        onChangeAction(
                            {
                                uuid: audience.uuid,
                                name: audience.name
                            },
                            e.target.value
                        )
                    }
                    width="152px"
                    height="32px"
                    size="12px"
                >
                    <option
                        key={"selectAction"}
                        value={"selectAction"}
                    >
                        Select Action
                    </option>
                    {AUDIENCE_ACTIONS_LIST.map(
                        (item, index) => {
                            return (
                                <option
                                    key={index}
                                    value={item.value}
                                >
                                    {item.label}
                                </option>
                            );
                        }
                    )}
                </InputSelector>
            }
        </>

    );
}
